import React, { useEffect, useState, useMemo } from "react";
import Pagination from "react-bootstrap/Pagination";
import SecBTN from "../../UI/SecBTN";

const PaginationComponent = ({
    total = 0,
    itemsPerPage = 5,
    currentPage = 1,
    onPageChange
}) => {
    console.log(total)
    const [totalPages, setTotalPages] = useState(total);

    useEffect(() => {
        if (total > 0 && itemsPerPage > 0)
            setTotalPages(Math.ceil(total / itemsPerPage));
        else
            setTotalPages(total)
    }, [total, itemsPerPage]);

    // if (totalPages === 0) return null;

    return (
      <div className="d-flex justify-content-between align-items-center">
        <SecBTN
          className={"sec-btn1"}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </SecBTN>
        <p>
          Page no. {totalPages !== 0 ? currentPage : totalPages}/{totalPages}
        </p>
        <SecBTN
          className={"sec-btn1"}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next
        </SecBTN>
      </div>
    );
};

export default PaginationComponent;

